export const VLYT = {
  nav: {
    logo: "nav-logo-link",
    home: "nav-link-home",
    about: "nav-link-about",
    founder: "nav-link-founder",
    support: "nav-link-support",
    app: "nav-link-app",
    installCta: "nav-install-cta",
    hamburger: "nav-hamburger-btn",
    mobileOverlay: "nav-mobile-overlay",
    mobileClose: "nav-mobile-close",
  },
  hero: {
    canvas: "hero-pulse-canvas",
    headline: "hero-headline",
    subhead: "hero-subhead",
    ctaPrimary: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
    scrollHint: "hero-scroll-hint",
  },
  friction: {
    stat: "friction-stat-counter",
    section: "friction-section",
  },
  handshake: {
    section: "handshake-section",
    nodeRider: "handshake-node-rider",
    nodeVlyt: "handshake-node-vlyt",
    nodeDriver: "handshake-node-driver",
    noSim: "handshake-no-sim",
  },
  royalty: {
    section: "royalty-section",
    card: "royal-rides-card",
    priceLine: "royal-rides-price",
    cta: "royal-rides-cta",
  },
  stats: { section: "stats-strip" },
  features: { section: "features-grid" },
  marquee: { section: "social-proof-marquee" },
  installBanner: {
    root: "install-banner",
    accept: "install-banner-accept",
    dismiss: "install-banner-dismiss",
  },
  waitlist: {
    trigger: "waitlist-trigger",
    modal: "waitlist-modal",
    email: "waitlist-email-input",
    role: "waitlist-role-select",
    submit: "waitlist-submit-btn",
    success: "waitlist-success-state",
    close: "waitlist-close-btn",
  },
  contact: {
    form: "contact-form",
    name: "contact-name-input",
    email: "contact-email-input",
    topic: "contact-topic-select",
    message: "contact-message-input",
    submit: "contact-submit-btn",
    success: "contact-success-state",
  },
  faq: {
    riderAccordion: "rider-faq-accordion",
    driverAccordion: "driver-faq-accordion",
  },
  footer: {
    root: "site-footer",
    year: "footer-year",
  },
  app: {
    installIos: "app-install-ios",
    installAndroid: "app-install-android",
    installPwa: "app-install-pwa",
  },
};
